import { memo, useState } from 'react'
import { XCircleIcon, X } from '@phosphor-icons/react'
import { useEditorErrorsStore } from './store.ts'

interface EditorErrorBannerProps {
  channel: 'A' | 'B'
}

export const EditorErrorBanner = memo(function EditorErrorBanner({
  channel,
}: EditorErrorBannerProps) {
  const errorMessage = useEditorErrorsStore(state =>
    state[channel === 'A' ? 'errorsA' : 'errorsB'].length > 0
      ? state[channel === 'A' ? 'errorsA' : 'errorsB'][0]?.message || null
      : null,
  )
  const dismissed = useEditorErrorsStore(state =>
    channel === 'A' ? state.dismissedA : state.dismissedB,
  )
  const setDismissed = useEditorErrorsStore(state =>
    channel === 'A' ? state.setDismissedA : state.setDismissedB,
  )
  const [copied, setCopied] = useState(false)

  if (!errorMessage || dismissed) return null

  const handleErrorClick = async () => {
    if (!errorMessage) return
    try {
      await navigator.clipboard.writeText(errorMessage)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy error:', err)
    }
  }

  const handleDismiss = (e: React.MouseEvent) => {
    e.stopPropagation()
    setDismissed?.(true)
  }

  return (
    <div
      onClick={handleErrorClick}
      className="absolute inset-0 bg-[#ff4444] text-white px-5 py-3 text-sm border-b border-[#ff6666] flex items-center gap-2 z-20 leading-tight cursor-pointer hover:bg-[#ff5555]"
      title="Click to copy error"
    >
      <XCircleIcon weight="fill" size={16} />
      <span className="flex-1">{copied ? 'Copied!' : errorMessage}</span>
      <button
        onClick={handleDismiss}
        className="flex-shrink-0 hover:bg-[#ff6666] rounded p-1"
        title="Dismiss"
      >
        <X size={16} weight="bold" />
      </button>
    </div>
  )
})
